import React, { useRef, useEffect } from 'react'

import CardDropAcoes from '../components/CardDropAcoes'
import DropdownDispositivos from '../components/DropdownDispositivos'
import ExportarImagem from '../components/ExportarImagem'
import FilterOption from '../components/FilterOption'
import ListaMostrarEmDispositivos from '../components/ListaMostrarEmDispositivos'
import MostrarHistorico from '../components/MostrarHistorico'

export function RenderMenuOpcoesMapeado(props) {
  const modal = useRef()
  const handleClickFora = (e) => {
    if (!modal.current?.contains(e.target)) handleCancelar()
  }

  function handleCancelar() {
    if (props.revelarOpcoesTecnologias) {
      props.setRevelarOpcoesTecnologias(!props.revelarOpcoesTecnologias)
    }
    if (props.revelarOpcoesTotalSimcardsOperadora) {
      props.setRevelarOpcoesTotalSimcardsOperadora(
        !props.revelarOpcoesTotalSimcardsOperadora
      )
    }
    if (props.revelarOpcoesStatusContrato) {
      props.setRevelarOpcoesStatusContrato(!props.revelarOpcoesStatusContrato)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSubLabel = (menuLabel, campo) => {
    const transformPart2 =
      ['contratos', 'operadoras'].includes(campo) || menuLabel === 'OUTRAS'
    if (menuLabel === 'DEMONSTRACAO') return 'Demonstração'
    const part1 = menuLabel.slice(0, 1).toUpperCase()
    let part2 = menuLabel.slice(1, menuLabel.length)
    return part1 + (transformPart2 ? part2.toLowerCase() : part2)
  }

  const objetoMenu = (props.arrayJSON || [])
    .filter((menu) => menu.nomeCampo !== null)
    .map((menu) => {
      const label = getSubLabel(menu.label, props.campo)

      if (props.campo === 'contratos') {
        return (
          <FilterOption
            key={'menu-' + menu.contratos + label}
            mostrarEmDispositivos={props.mostrarEmDispositivos}
            item={{ clickParam: { STATUS_CONTRATO: menu.label }, label }}
          />
        )
      }
      if (props.campo === 'operadoras') {
        return (
          <FilterOption
            key={'menu-' + menu.operadoras + label}
            mostrarEmDispositivos={props.mostrarEmDispositivos}
            item={{ clickParam: { OPERADORA: menu.cd_operadora }, label }}
          />
        )
      }
      if (props.campo === 'tecnologias') {
        let lbl = menu.label
        if (lbl == 'NB') lbl = lbl + '-IoT'
        return (
          <FilterOption
            key={'menu-' + menu.tecnologias + label}
            mostrarEmDispositivos={props.mostrarEmDispositivos}
            item={{ clickParam: { TECNOLOGIA: menu.label }, label: lbl }}
          />
        )
      }
      return null
    })

  return (
    <CardDropAcoes modal={modal}>
      <li>
        <DropdownDispositivos dropMenuOpcoes={props.dropMenuOpcoes} />
        <ul
          id="menu-mostrar-em-dispositivos"
          className="drop-acoes-lista-submenu dropdown-desativado"
        >
          {objetoMenu}
        </ul>
      </li>
      <ExportarImagem exportar={props.exportar} />
    </CardDropAcoes>
  )
}

export function RenderMenuOpcoesSimcardsStatus(props) {
  const modal = useRef()
  const handleClickFora = (e) => {
    if (!modal.current?.contains(e.target)) handleCancelar()
  }

  function handleCancelar() {
    if (props.revelarOpcoesSimcardsStatus) {
      props.setRevelarOpcoesSimcardsStatus(!props.revelarOpcoesSimcardsStatus)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <CardDropAcoes modal={modal}>
      <ListaMostrarEmDispositivos
        tipo="status"
        dropMenuOpcoes={props.dropMenuOpcoes}
        mostrarEmDispositivos={props.mostrarEmDispositivos}
      />
      <ExportarImagem exportar={props.exportar} />
    </CardDropAcoes>
  )
}

export function RenderMenuOpcoesSimcardSemComunicar(props) {
  const modal = useRef()
  const handleClickFora = (e) => {
    if (!modal.current?.contains(e.target)) handleCancelar()
  }

  function handleCancelar() {
    if (props.revelarOpcoesSimcardsSemComunicar) {
      props.setRevelarOpcoesSimcardsSemComunicar(
        !props.revelarOpcoesSimcardsSemComunicar
      )
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <CardDropAcoes modal={modal}>
      <ListaMostrarEmDispositivos
        tipo="semComunicar"
        dropMenuOpcoes={props.dropMenuOpcoes}
        mostrarEmDispositivos={props.mostrarEmDispositivos}
      />
      <ExportarImagem exportar={props.exportar} />
    </CardDropAcoes>
  )
}

export function RenderMenuOpcoesConsumo(props) {
  const modal = useRef()
  const handleClickFora = (e) => {
    if (!modal.current?.contains(e.target)) handleCancelar()
  }

  function handleCancelar() {
    if (props.revelarOpcoesConsumo) {
      props.setRevelarOpcoesConsumo(!props.revelarOpcoesConsumo)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <CardDropAcoes modal={modal} isConsumo={props.showHistoricoConsumo}>
      <ExportarImagem exportar={props.exportar} />
      {props.showHistoricoConsumo && (
        <MostrarHistorico
          showHistoricoConsumo={props.showHistoricoConsumo}
          consumoNoCicloDash={props.consumoNoCicloDash}
          setConsumoNoCicloDash={props.setConsumoNoCicloDash}
          setLabelDashboardConsumo={props.setLabelDashboardConsumo}
          handleCancelar={handleCancelar}
          notHasSharedPlan={props.notHasSharedPlan}
          openAlertaSharedPlan={props.openAlertaSharedPlan}
        />
      )}
    </CardDropAcoes>
  )
}
